"use client"

import { useRouter } from "next/navigation"

import { ChevronLeftIcon } from "@/src/shared/assets/icons"

import { texts } from "./localization/texts"

export function BackButton() {
  const router = useRouter()

  return (
    <button
      type="button"
      aria-label={texts.back}
      className="inline-flex size-11 shrink-0 cursor-pointer items-center justify-center justify-self-start rounded-[10px] border border-black-ink-800 bg-black-600"
      onClick={() => router.back()}
    >
      <ChevronLeftIcon aria-hidden className="size-4 text-white" />
    </button>
  )
}
